module.exports = __webpack_public_path__ + "img/BKM_DTP.f6ff17a3.jpg";